module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/20e38f264d2f5995b1bae447598b0539.png";